import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import popup_msg_sound_effect from "../../sounds/sentmessagesound.mp3";
import useSoundPlayer from "../authmodule/deshboard/commonmodal/useSoundPlayer";

const NotificationContext = createContext();
export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const sounddata = useSelector((state) => state.usersound.sound);
  const { loadSound, playSound } = useSoundPlayer(0.1);
  // const popupSound = new Audio(popup_msg_sound_effect);
  const [notifications, setNotifications] = useState([]);
  const notificationRef = useRef();
  const location = window.location;
  const pathSegments = location.pathname.split("/");
  const [addclass, setAddclass] = useState(false);
  const timers = useRef({});
  useEffect(() => {
    loadSound("notification", popup_msg_sound_effect);
  }, []);
  const playPopupSound = () => {
    if (!sounddata) return;
    playSound("notification");
  };
  const showNotification = (message, type = "success") => {
    const id = Date.now();
    // if(sounddata){
    playPopupSound();
    // }

    const newNotification = {
      id,
      message,
      type,
      removing: false,
    };

    setNotifications((prev) => {
      const trimmed = prev.length >= 4 ? prev.slice(1) : prev;
      return [newNotification, ...trimmed];
    });

    // clear existing timers for same id if any
    if (timers.current[id]) {
      clearTimeout(timers.current[id].removeTimer);
      clearTimeout(timers.current[id].fadeTimer);
    }

    // fade out after 3s
    timers.current[id] = {};
    timers.current[id].fadeTimer = setTimeout(() => {
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, removing: true } : n)),
      );

      // remove after fade animation
      timers.current[id].removeTimer = setTimeout(() => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
        delete timers.current[id]; // cleanup
      }, 500);
    }, 3000);
  };
  useEffect(() => {
    if (pathSegments[2] === "userdashboard") {
      setAddclass(true);
    } else {
      setAddclass(false);
    }
  }, [pathSegments]);
  useEffect(() => {
    if (notifications?.length >= 5) {
      setNotifications([]);
    }
  }, [notifications?.length]);
  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}

      <div className={`notification-container allpopups ${addclass ? "" : ""}`}>
        <div className="notification-pop ">
          {notifications.map((notification) => (
            <NotificationItem key={notification.id} data={notification} />
          ))}
        </div>
      </div>
    </NotificationContext.Provider>
  );
};

const NotificationItem = ({ data }) => {
  const notificationRef = React.useRef();

  useEffect(() => {
    const element = notificationRef.current;
    requestAnimationFrame(() => {
      element?.classList?.add("show");
    });

    // if (data?.removing) {
    //   element?.classList?.add("hide");
    // }
  }, [data?.removing]);

  return (
    <div
      ref={notificationRef}
      className={`notification ${data?.removing ? "hide show" : ""}`}
    >
      <div className="custom-msg text-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill={
            data.type === "success"
              ? "rgba(100,205,138,1)"
              : "rgba(243,89,89,1)"
          }
        >
          {data.type === "success" ? (
            <path d="M11.602 13.7599L13.014 15.1719L21.4795 6.7063L22.8938 8.12051L13.014 18.0003L6.65 11.6363L8.06421 10.2221L10.189 12.3469L11.6025 13.7594L11.602 13.7599ZM11.6037 10.9322L16.5563 5.97949L17.9666 7.38977L13.014 12.3424L11.6037 10.9322ZM8.77698 16.5873L7.36396 18.0003L1 11.6363L2.41421 10.2221L3.82723 11.6352L3.82604 11.6363L8.77698 16.5873Z" />
          ) : (
            <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 15V17H13V15H11ZM11 7V13H13V7H11Z" />
          )}
        </svg>
        {data.message}
      </div>
    </div>
  );
};
